import {GameStateEnums} from '../../../../../shared/GameEnums'
import {UIGameMechanic} from '../UIGameEventController'
import {UIGameManager} from '../UIGameManager'
import {UIGameHelpButtons} from './UIGameHelpButtons'
import UIGameSpectatorDisplay from './UIGameSpectatorDisplay'
import UIGameEventEnums = GameStateEnums.UIGameEventEnums
import {SpectatorData} from '@colonist/game-state-types'

export abstract class UIGameHelpButtonsController implements UIGameMechanic {
    readonly uiGameManager: UIGameManager

    protected view: UIGameHelpButtons
    protected spectatorDisplay: UIGameSpectatorDisplay

    constructor(uiGameManager: UIGameManager) {
        this.uiGameManager = uiGameManager
        this.uiGameManager.eventController.registerUIGameMechanic(this)
    }

    onEvent(data: any, eventType: UIGameEventEnums) {
        switch(eventType) {
            case UIGameEventEnums.CanvasResized: this.resizeHelpButtons(); break
            case UIGameEventEnums.GameEnd:
            case UIGameEventEnums.GameEndHideMap: this.hide(); break
            case UIGameEventEnums.GameEndShowMap: this.show(); break
            case UIGameEventEnums.SpectatorDataUpdated: this.updateSpectatorData(data); break
            case UIGameEventEnums.KarmaUpdated: this.onKarmaUpdated(); break
            case UIGameEventEnums.CanResign: this.updateLeaveGameButton(); break
            default: break
        }
    }

    onKarmaUpdated() {
        this.uiGameManager.settingsController.updateGameSettings()
    }

    private updateLeaveGameButton() {
        this.view.settingsButton?.updateDropdownValues()
    }

    private resizeHelpButtons() {
        this.view.resize()
    }

    private updateSpectatorData(value: SpectatorData[]) {
        void this.spectatorDisplay.updateSpectatorData(value)
    }

    closeAllContainers() {
        this.view.closeAllContainers()
    }

    private hide() {
        if(this.uiGameManager.gameController.isReplay) return

        this.view.hide()
    }

    private show() {
        this.view.show()
    }
}
